import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { IAppointment } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractDetailsComponent } from '../../../shared/abstracts/details/abstract-details/abstract-details.component';


@Component({
  selector: 'inc-appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: ['./appointment-details.component.scss'],
})
export class AppointmentDetailsComponent extends AbstractDetailsComponent<{ appointment: IAppointment, files: File[] }> implements OnInit {
  appointment: IAppointment;
  files: File[];
  @Output() callOpenFile = new EventEmitter<number>();

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.inData) {
      this.appointment = this.inData.appointment ? this.inData.appointment : null;
      this.files = this.inData.files ? this.inData.files : [];
    }
  }

  openFile(i: number) {
    this.callOpenFile.emit(i);
  }
}
